import * as React from 'react';
import { TouchableOpacity, View } from 'react-native';
import Animated, { interpolateColor, useAnimatedStyle } from 'react-native-reanimated';
import { hitSlopXS, IconClose, rem, Spacer } from 'design-system';
import useStyles from 'hooks/useStyles';
import useColors from 'hooks/useColors';
import createStyleSheets from 'utils/createStyleSheets';
const ItemBadgeWrapper = ({ scrollY, children, onCancel, handlePress, scrollToItem, isActiveKeyboard, }) => {
    const ref = React.useRef(null);
    const colors = useColors();
    const styles = useStyles(styleSet);
    const animatedBgStyles = useAnimatedStyle(() => ({
        backgroundColor: interpolateColor(scrollY.value, [0, 40], [
            colors.background.dark,
            colors.cards.onDark,
        ]),
    }), [colors.background.dark, colors.cards.onDark, scrollY]);
    React.useEffect(() => {
        if (isActiveKeyboard) {
            const timeout = setTimeout(() => {
                ref.current?.measure((_x, _y, _width, _height, pageX) => {
                    scrollToItem(pageX);
                });
            }, 50);
            return () => {
                clearTimeout(timeout);
            };
        }
        return () => { };
    }, [isActiveKeyboard, scrollToItem]);
    return (<View ref={ref} collapsable={false}>
      <TouchableOpacity activeOpacity={1} disabled={!handlePress} onPress={handlePress}>
        <Animated.View style={[styles.container, animatedBgStyles]}>
          {children}
          <Spacer w={4}/>
          <TouchableOpacity onPress={onCancel} hitSlop={hitSlopXS}>
            <IconClose alt size={16} color={colors.elements.secondary}/>
          </TouchableOpacity>
        </Animated.View>
      </TouchableOpacity>
    </View>);
};
export default React.memo(ItemBadgeWrapper);
const styleSet = createStyleSheets((colors) => ({
    container: {
        height: rem(26),
        alignItems: 'center',
        flexDirection: 'row',
        borderRadius: rem(14),
        paddingHorizontal: rem(6),
        marginRight: rem(4),
        backgroundColor: colors.background.dark,
    },
}));
